<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="programmeCommitte.id"
        :hasError="!!errors.id"
        id="id"
      />
      <div class="form-col" v-if="!showEdit">
        <field
          :label="$t('programmeCommitte.employee')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <multiselect
            ref="employeSelect"
            v-model="selected"
            :options="employeeList"
            label="name"
            :close-on-select="false"
            placeholder="Select users"
            @select="onSelect"
            mode="tags"
            trackBy="value"
            :searchable="true"
          />
        </field>
      </div>
      <div class="form-col" v-if="showEdit">
        <field
          :label="$t('programmeCommitte.employee')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.employee_id"
        >
          <multiselect
            ref="employeSelect"
            v-model="programmeCommitte.employee_id"
            :options="employeeList"
            label="name"
            :close-on-select="false"
            placeholder="Select users"
            @select="onSelect"
            mode="single"
            trackBy="value"
            :disabled="true"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('programmeCommitte.role')"
          class="w-full md:ml-2 mb-2 md:mb-0"
          :hasError="errors.committe_role_id"
        >
          <control
            :options="committeRoleList"
            :placeholder="$t('programmeCommitte.placeholder.roleselect')"
            v-model="programmeCommitte.committe_role_id"
            id="committe_role_id"
            :hasError="!!errors.committe_role_id"
          />
        </field>
      </div>

      <div class="flex flex-wrap mx-4 mb-2">
        <field
          :label="$t('programmeCommitte.jobdescription')"
          class="form-col-input-full"
          :hasError="errors.job_description"
        >
          <vue-editor :editorToolbar="customToolbar" v-model="programmeCommitte.job_description" />
        </field>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>

</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  computed,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
import { VueEditor } from "vue3-editor";
//   import CheckRadioPicker from '@/components/CheckRadioPicker'
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import Multiselect from "@vueform/multiselect";
import { useToast } from "vue-toastification";
//   import Datepicker from '@vuepic/vue-datepicker'
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { getDepartmentDataAll } from "@/composables/global";
// import { Year } from '@syncfusion/ej2-vue-schedule'
export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    //   CheckRadioPicker,
    VueEditor,
    JbButton,
    Multiselect,
    //   Datepicker,
    JbButtons,
  },
  props: {
    showEdit: { Boolean },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    programmeId: {
      type: String,
      default: "",
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const isLoading = ref(false);

    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);

    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const selected = ref([]);
    const employeSelect = ref(null);
    const programmeList = ref();
    const employeeList = ref([]);
    const committeRoleList = ref();

    const programmeCommitte = reactive({
      id: "",
      programme_id: "",
      employee_id: [],
      committe_role_id: "",
      job_description: "",
    });

    const { departmentList } = getDepartmentDataAll();

    const reset = () => {
      // programmeCommitte.programme_id = ''
      programmeCommitte.employee_id = [];
      programmeCommitte.committe_role_id = "";
      programmeCommitte.job_description = "";
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "programme-committe/" + programmeCommitte.id
        : "programme-committe";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        programmeCommitte.created_by = userlogin;
        programmeCommitte.employee_id = selected.value;
      } else {
        programmeCommitte.updated_by = userlogin;
      }

      const jsonData = JSON.stringify(programmeCommitte);
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };
      await axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getProgramme = async () => {
      isLoading.value = true;
      await axios
        .get("programme")
        .then((response) => {
          programmeList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getEmployee = async () => {
      isLoading.value = true;
      const userId = localStorage.getItem('user_id')
      const branchId = localStorage.getItem('branch_id')
      const params = {
        user_id: userId,
        branch_id: branchId
      }
      await axios
        .get("employee", { params })
        .then((response) => {
          isLoading.value = false;
          const data = response.data.data;
          employeeList.value = [
            { value: "__all__", name: "Select All" },
            ...data.map((emp) => ({
              value: emp.id,
              name: emp.name,
            })),
          ];
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getCommitteRole = async () => {
      isLoading.value = true;
      await axios
        .get("committe-role")
        .then((response) => {
          committeRoleList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const normalizedEmployees = computed(() => {
      const base = employeeList.value.map((emp) => ({
        value: emp.value, // assume API returns `id`
        name: emp.name, // and `name`
      }));
      if (programmeCommitte.employee_id === "__all__") {
        return [{ value: "__all__", name: "Select All" }, ...base];
      }
      return base;
    });

    // Select All logic
    const onSelect = (option) => {
      console.log("option.value", option);
      if (option === "__all__") {
        console.log("normalizedEmployees", normalizedEmployees.value);
        selected.value = normalizedEmployees.value
          .filter((opt) => opt.value !== "__all__")
          .map((opt) => opt.value);
      }
    };

    watch(
      () => props.showEdit,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          if (props.showEdit) {
            employeeList.value = normalizedEmployees.value.filter(
              (opt) => opt.value !== "__all__"
            );
          } else {
            employeeList.value = [
              { value: "__all__", name: "Select All" },
              ...normalizedEmployees.value,
            ];
          }
        }
      }
    );

    onBeforeMount(() => {});

    onMounted(() => {
      getProgramme();
      getEmployee();
      getCommitteRole();
    });

    watch(
      () => props.programmeId,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          programmeCommitte.programme_id = newVal;
        }
      }
    );

    watchEffect(() => {
      const newprogrammecommitte = props.propClass;
      Object.assign(programmeCommitte, newprogrammecommitte);
    });

    return {
      isLoading,
      titleStack,
      programmeList,
      employeeList,
      committeRoleList,
      // customElementsForm,
      mdiBallot,
      mdiCheckBold,
      router,
      getProgramme,
      getEmployee,
      getCommitteRole,
      programmeCommitte,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      departmentList,
      onSelect,
      selected,
      employeSelect,
      normalizedEmployees,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
    };
  },
  methods: {
    clearForm() {
      this.programmeCommitte = reactive({
        id: "",
        programme_id: "",
        employee_id: [],
        committe_role_id: "",
        job_description: "",
        created_by: "",
      });
    },
    onChange: function (programme_id, event) {
      if (event.target.value) {
        programme_id = event.target.value;
      }
    },
  },
  // created () {
  //   this.levelListFilter = this.levelList
  //   this.academicYearListFilter = this.academicYearList
  // }
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
